import {PolarArea, mixins} from 'vue-chartjs'

export default {
    extends: PolarArea,
    mixins: [mixins.reactiveProp],
    props: ['chartData', 'options'],
    mounted() {
        // this.chartData создаётся внутри миксина.
        // Если вы хотите передать опции, создайте локальный объект options
        this.renderChart(this.chartData, this.options)
    }
}